export default "__VITE_ASSET__CMg6lBq0__"